window.theme.block('materias-4-social', el => {
    const root = el.querySelector('[data-manchete-slider]');
    const track = el.querySelector('.js-manchete-slider-track');
    const slides = track ? Array.from(track.querySelectorAll('.js-manchete-slide')) : [];
    const prevBtn = el.querySelector('.js-manchete-prev');
    const nextBtn = el.querySelector('.js-manchete-next');

    if (root && track && slides.length > 1) {
        let index = 0;
        let timer;

        const goTo = (i) => {
            index = ((i % slides.length) + slides.length) % slides.length;
            const left = slides[index].offsetLeft;
            track.scrollTo({ left, behavior: 'smooth' });
        };

        const next = () => goTo(index + 1);
        const prev = () => goTo(index - 1);

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                next();
                window.clearInterval(timer);
                timer = window.setInterval(next, 6000);
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                prev();
                window.clearInterval(timer);
                timer = window.setInterval(next, 6000);
            });
        }

        const start = () => {
            window.clearInterval(timer);
            timer = window.setInterval(next, 6000);
        };

        track.addEventListener('mouseenter', () => window.clearInterval(timer));
        track.addEventListener('mouseleave', start);

        let scrollEndTimer;
        track.addEventListener('scroll', () => {
            window.clearTimeout(scrollEndTimer);
            scrollEndTimer = window.setTimeout(() => {
                const x = track.scrollLeft;
                let best = 0;
                let bestDist = Infinity;
                slides.forEach((slide, j) => {
                    const d = Math.abs(slide.offsetLeft - x);
                    if (d < bestDist) {
                        bestDist = d;
                        best = j;
                    }
                });
                if (best !== index) {
                    index = best;
                }
            }, 80);
        });

        start();
    }

    const videoWrapper = el.querySelector('.video-wrapper');
    const buttonWrapper = el.querySelector('.play-button-wrapper');
    const playButton = el.querySelector('.video-play-button');
    const stopButton = el.querySelector('.stop-video');

    if (playButton && videoWrapper) {
        playButton.addEventListener('click', function () {
            videoWrapper.classList.add('playing');
        });
    }

    if (stopButton && videoWrapper) {
        stopButton.addEventListener('click', function () {
            const iframe = el.querySelector('.video-player iframe');
            if (!iframe) {
                return;
            }
            let src = iframe.getAttribute('src');
            if (src && !src.includes('mute=1')) {
                src = src.replace('mute=0', 'mute=1');
                iframe.setAttribute('src', src);
            }
            if (buttonWrapper) {
                buttonWrapper.style.display = 'block';
            }
            videoWrapper.classList.remove('playing');
        });
    }

    if (videoWrapper) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    videoWrapper.classList.remove('fixed');
                } else {
                    videoWrapper.classList.add('fixed');
                }
            });
        }, { threshold: 0 });
        observer.observe(videoWrapper);
    }
});
